var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { domainService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject } from "~/core/decorator";
import { FilterService } from '~/utils/filter.service';
var RobCaseService = /** @class */ (function () {
    function RobCaseService() {
    }
    /**
     * 获取抢案案件数据
     */
    RobCaseService.prototype.robCasesQuery = function (data, page, sort) {
        return this.netService.send({
            server: domainService.robCaseController.robCasesQuery,
            data: {
                caseNumber: data.caseNumber,
                personalName: data.personalName,
                mobileNo: data.mobileNo,
                idCard: data.idCard,
                deptId: data.deptIds.length === 0 ? '' : data.deptIds[data.deptIds.length - 1],
                area: data.area,
                currentCollectorRealName: data.currentCollectorRealName,
                customerCategory: data.customerCategory,
                overdueAmountMax: data.overdueAmount.max,
                overdueAmountMin: data.overdueAmount.min,
                overduePeriod: data.overduePeriod,
                overdueDaysMax: data.overdueDays.max,
                overdueDaysMin: data.overdueDays.min,
                followupBack: data.followupBack,
                turnSource: data.turnSource,
                productCategory: data.productCategory,
                productName: data.productName,
                followInTimeMin: FilterService.dateRanageFormat(data.followInTime).start,
                followInTimeMax: FilterService.dateRanageFormat(data.followInTime).end,
                labelName: data.labelName,
                caseMoneyMin: data.caseMoney ? data.caseMoney.min : '',
                caseMoneyMax: data.caseMoney ? data.caseMoney.max : '',
            },
            page: page,
            sort: sort
        });
    };
    /**
     * 获取抢案案件跟进记录
     */
    RobCaseService.prototype.queryFollowupRecords = function (data, page, sort) {
        return this.netService.send({
            server: domainService.robCaseController.queryFollowupRecords,
            data: {
                caseId: data
            },
            page: page,
            sort: sort
        });
    };
    /**
     * 抢案--分案
     * @param data
     */
    RobCaseService.prototype.distributeRobCase = function (data) {
        return this.netService.send({
            server: domainService.robCaseController.distributeRobCase,
            data: data,
            loading: true
        });
    };
    __decorate([
        Inject(NetService)
    ], RobCaseService.prototype, "netService", void 0);
    return RobCaseService;
}());
export { RobCaseService };
